export default __webpack_public_path__ + "assets/e88a40bdec72973dc03e524d209700f8.svg";